import type { RepeatOptionType } from '@/components/Note/components/TodoModal/util';
import type { CommonResponse } from '@/utils/request';
import { Request } from '@/utils/request';

import type { ITodoListItem } from './note';

export enum ETodoStatus {
  done = 'done',
  undone = 'undone'
}

export interface IAddTodoListItemParam {
  mindId: string;
  sessionId?: string;
  deadline?: number | ''; // 约定 '' 为将 deadline 置空
  content?: string;
  detail?: string;
  source?: string;
  reminderTime?: number | '';
  status?: ETodoStatus;
  repeatType?: RepeatOptionType;
  endReminderDate?: number | ''; // 终止重复的日期, 为空则永不终止
}

export interface IPutTodoListItemParam extends IAddTodoListItemParam {
  id: number;
}

export interface WS_MSG_MULTIPLE_TEMPLATE_PARAMS_TODO {
  dataMap: {
    id: string;
    deadline: Date;
    content: string;
    status: ETodoStatus;
    detail?: string;
    reminderTime?: Date;
  };
  citationId: string;
}

// deprecated
export function addTodo(data: IAddTodoListItemParam) {
  return Request<CommonResponse<any>>({
    url: '/rest/os/task/todo/add',
    method: 'post',
    data: {
      ...data,
      status: ETodoStatus.undone
    }
  });
}

export function deleteTodo(data: { id: number; mindId: string }) {
  return Request<CommonResponse<any>>({
    url: '/rest/os/task/todo/delete',
    method: 'post',
    data
  });
}

export function updateTodo(data: IPutTodoListItemParam) {
  return Request<CommonResponse<any>>({
    url: '/rest/os/task/todo/update',
    method: 'post',
    data
  });
}

export function getTodoDetail(data: { id: number }) {
  return Request<CommonResponse<ITodoListItem>>({
    url: '/rest/os/task/todo/detail',
    method: 'get',
    params: data
  });
}
